import React from 'react';
import styled from 'styled-components';
//import { classic } from '~/themes';
import bg from '@assets/images/background/mode-solo.png';
import bgText from '@assets/images/background/mode-solo-text.svg';
import { Trans } from '@lingui/react';
import { classic } from '~/themes';

type IProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  hidden?: boolean;
  onClickRancking?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function ButtonSolo({
  onClick,
  disabled,
  hidden,
  onClickRancking,
}: IProps) {
  return (
    <Wrapper>
      <SDivScore onClick={onClickRancking}>
        <SSpan>
          <Trans id="common.rancking" />
        </SSpan>
      </SDivScore>
      <Container
        $background={bg}
        disabled={disabled}
        hidden={hidden}
        onClick={onClick}
      >
        <img src={bgText} alt="" />
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  border-radius: 60px 16px 16px 16px;
  border: 3px solid #fff;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;

  @media screen and (max-width: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 16px 16px 16px 16px;
    }
  }
  @media screen and (max-height: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 16px 16px 16px 16px;
    }
  }
`;

// color: ${({ $color }) =>  $color ? $color : `${classic.token?.colorText}`}!important;
const Container = styled.button<{
  disabled?: boolean;
  hidden?: boolean;
  $background?: string;
}>`
  cursor: pointer;
  border: none;
  background: ${({ $background }) =>
    $background ? `url('${$background}') center/cover no-repeat` : 'none'};
  opacity: ${({ disabled, hidden }) => {
    if (hidden) return 0;
    if (disabled) return 0.5;

    return 1;
  }};
  position: relative;
  overflow: hidden;
  pointer-events: ${({ disabled, hidden }) =>
    (disabled ?? hidden) ? 'none' : 'auto'};
  transition: all 0.6s linear;
  height: 82%;
  width: 100%;

  img {
    position: absolute;
    object-fit: contain;
    left: 0;
    bottom: 0;
    height: auto;
    width: 65%;
    transition: all 0.5s linear;

    @media screen and (orientation: portrait) {
      width: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &:hover {
    border: none;
    img {
      transform: scale(1.1);
    }
  }

  &:focus {
    border: none;
    img {
      transform: scale(1.1);
    }
  }
`;

const SDivScore = styled.button`
  align-items: center;
  display: flex;
  border: none;
  justify-content: center;
  border-radius: 62px 14px 0px 0px;
  background: linear-gradient(180deg, #53d2d7 0%, #27c4ca 100%);
  box-shadow: 0px -4px 3px 0px rgba(0, 0, 0, 0.25) inset;
  height: 18%;
  width: 100%;
  &:hover {
    border: none;
    div {
      transform: scale(1.1);
    }
  }

  &:focus {
    border: none;
    div {
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 14px 14px 0px 0px;
    }
  }
  @media screen and (max-height: 450px) {
    @media screen and (orientation: portrait) {
      border-radius: 14px 14px 0px 0px;
    }
  }
`;

const SSpan = styled.div`
  color: ${classic.token?.colorWhite};
  text-align: center;
  visibility: visible;
  font-family: 'Riffic Free', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  transition: all 0.5s linear;

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 800px) {
    font-size: 1.2rem;
  }
  @media screen and (max-height: 500px) {
    font-size: 1rem;
  }
`;
